export function isOther(input: string): boolean {
	return input.toLowerCase() === 'oth' || input.toLowerCase() === 'other';
}
